export default __webpack_public_path__ + "static/media/can.57f20b87.svg";